<template>
  <!-- TrialBanner has several roots (banner, dialogs, toast): wrapped for the spacing -->
  <div v-if="applicable" class="mb-[3px]">
    <TrialBanner
      :org-id="orgId"
      :subscription="subscription"
      square
      @changed="refresh"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useAuth } from "../../composables/use-auth";
import { useOrg } from "../../composables/use-org";
import { useOrgSubscription } from "../../composables/use-org-subscription";
import { isOwnTrial, SUBSCRIPTION_ROUTE } from "../../config/licensing";
import TrialBanner from "./TrialBanner.vue";

// The trial countdown on every page of the app shell, for the selected
// organization. Mounted only for its org admins (see layouts/dashboard.vue).

const route = useRoute();
const { selectedMembership } = useAuth();
const { org, fetchOrg } = useOrg();
// shares its cache with the subscription page
const { subscription, fetchSubscription } = useOrgSubscription();

const orgId = computed(() => selectedMembership.value?.organizationId ?? null);

const applicable = computed(
  () =>
    // the org of the current selection, loaded: a Managed org (which sees
    // its Manager's trial) must not flash the banner meanwhile
    !!org.value &&
    org.value.id === orgId.value &&
    isOwnTrial(subscription.value, org.value.kind) &&
    // the subscription page shows it itself
    route.path !== SUBSCRIPTION_ROUTE,
);

const refresh = () => Promise.all([fetchOrg(orgId.value), fetchSubscription()]);
</script>
